function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 3338.11,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M45289 41884l-19152 -14486 -2800 -8035 8494 505 19151 14487c996,753 1652,1870 1823,3107 172,1236 -156,2490 -908,3486l-18 23c-1568,2071 -4517,2481 -6590,914zm-9128 -27420l0 -6675c0,-1844 -1495,-3338 -3338,-3338l-26703 0c-1843,0 -3337,1495 -3337,3338l0 33379c0,1844 1495,3338 3337,3338l15577 0 7789 6675 0 -6675 3337 0c1265,0 2421,-714 2987,-1845m-26352 -31534l10013 0m-5007 0l0 10014m-5007 8345l8345 0m-8345 6675l13352 0"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 55632 55632",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/scripts.6707b64b.svg";
export { SvgComponent as ReactComponent };